@let uploadDocumentName =
  progressBarItem().isUploaded
    ? progressBarItem().title
    : progressBarItem().name;
@let errorMessage = $errorMessage();
<div class="progress-bar-container">
  <div
    class="progress-status"
    [ngClass]="{
      'progress-error': progress() === 100 && progressBarItem().isError,
      'progress-success': progress() === 100 && progressBarItem().isUploaded,
    }"
  >
    <span title="{{ uploadDocumentName }}" class="upload_files">
      {{ uploadDocumentName }}
    </span>

    @if (progress() < 100) {
      <span
        class="progress-close"
        (click)="onCancelUpload(progressBarItem())"
        tabindex="0"
      >
        &#10005;</span
      >
    }
    @if (progress() === 100 && progressBarItem().isUploaded) {
      <span class="progress_popup_success">
        <mat-icon class="success_icon">check_circle</mat-icon>
      </span>
    }
    @if (progress() === 100 && progressBarItem().isError) {
      <span class="progress_popup_fail">
        <mat-icon matTooltip="{{ errorMessage }}" matTooltipPosition="above"
          >error</mat-icon
        >
      </span>
    }
  </div>
  <div [hidden]="progressBarItem().isError || progressBarItem().isUploaded">
    <mat-progress-bar color="accent" [value]="progress()"></mat-progress-bar>
  </div>
</div>
@if (progress() === 100 && progressBarItem().isError) {
  <span
    class="progress_file_error"
    matTooltip="{{ errorMessage }}"
    matTooltipPosition="above"
  >
    {{ errorMessage }}
  </span>
}
<span [hidden]="progressBarItem().isError || progressBarItem().isUploaded">
  Processing...
</span>
